import { useQuery } from 'hooks/useCustomQuery';
import getAppAuthByCompanyId from '@/API/AppAuth/getAppAuthByCompanyId';

const useGetAppAuthByCompanyId = (companyId) => {
    return useQuery({
        queryKey: ['AppAuth', companyId],
        queryFn: async () => {
            const response = await getAppAuthByCompanyId(companyId);
            return response.data;
        },
        refetchOnWindowFocus: false,
        staleTime: 0,
        cacheTime: 0,
        enabled: !!companyId,
    });
};

export default useGetAppAuthByCompanyId;
